import * as XLSX from "xlsx";
import React, { useEffect, useState } from "react";
import Sidebar from "../Components/Sidebar";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import excel from "../assests/images/excel img.png";
import EditAdminsForm from "./EditAdminsForm";
import CreateAdminsForm from "./CreateAdminsForm";
import Constant from "../Components/Utils/Constant";
import axios from "axios";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditAdminForm from "../Components/models/EditAdminForm";
import { useSelector } from "react-redux";

export default function Admins() {
  const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
  const [showAdminForm, setShowAdminForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showBlockConfirmation, setShowBlockConfirmation] = useState(false);
  const [admin, setAdmin] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [dropdownStates, setDropdownStates] = useState(
    Array(admin.length).fill(false)
  );
  const tableRef = React.createRef();
  const [editPopup, setEditPopup] = useState(false);
  const [adminToDelete, setAdminToDelete] = useState(null);
  const [adminToBlock, setAdminToBlock] = useState(null);
  const highlightedId = useSelector((state) => state.DataReducer.highlightedId);
  const userRes = useSelector((state) => state?.DataReducer?.user);
  const [selectedOption, setSelectedOption] = useState(""); // State to track the selected option
  const [createdByFilter, setCreatedByFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState(""); // "" = all, "blocked", "active"

  // New sorting states
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: null
  });

  // Function to handle sorting
  const handleSort = (column) => {
    let direction = 'asc';
    if (sortConfig.key === column && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key: column, direction });
  };

  // Function to get sorted data
  const getSortedData = (data) => {
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      if (sortConfig.key === 'demoUsers') {
        aValue = userRes?.admins?.filter((user) => 
          user.createdby === a.name && user.usertype === "Demo"
        ).length;
        bValue = userRes?.admins?.filter((user) => 
          user.createdby === b.name && user.usertype === "Demo"
        ).length;
      } else if (sortConfig.key === 'salesUsers') {
        aValue = userRes?.admins?.filter((user) => 
          user?.createdby === a?.name && user?.usertype === "Sales"
        ).length;
        bValue = userRes?.admins?.filter((user) => 
          user?.createdby === b?.name && user?.usertype === "Sales"
        ).length;
      }

      if (sortConfig.direction === 'asc') {
        return aValue - bValue;
      } else {
        return bValue - aValue;
      }
    });
  };

  // Function to render sort icon
  const renderSortIcon = (column) => {
    if (sortConfig.key !== column) {
      return <MdArrowDropDown className="inline ml-1 cursor-pointer opacity-50" />;
    }
    return sortConfig.direction === 'asc' 
      ? <MdArrowDropUp className="inline ml-1 cursor-pointer" />
      : <MdArrowDropDown className="inline ml-1 cursor-pointer" />;
  };

  // Function to handle option selection
  const handleOptionChange = (event, admin) => {
    const selectedValue = event.target.value;
    if (selectedValue === "Edit") {
      setEditPopup(admin);
    } else if (selectedValue === "Delete") {
      handleOpenDeleteConfirmation(admin._id);
    } else if (selectedValue === "block") {
      handleBlockConfirmation(admin);
    }
  };
  
  // select options toggle
  const toggleDropdown = (index) => {
    if (dropdownStates === index) {
      setDropdownStates(null); // Close the dropdown if the same index is clicked
    } else {
      setDropdownStates(index); // Open the clicked dropdown
    }
  };

  // select filter dropdown
  const toggleDropdownfilter = () => {
    setIsDropdownOpenfilter(!isDropdownOpenfilter);
  };

  // create admins form
  const handleCreateAdminClick = () => {
    setShowAdminForm(true);
  };
  const handleClosePopup = () => {
    setShowAdminForm(false);
  };
  // Edit form pop up

  const handleCloseEdit = () => {
    setShowEditForm(false);
  };

  // State for confirmation popups

  const handleConfirmation = (confirmationType) => {
    setDropdownStates(false);

    if (confirmationType === "delete") {
      setShowDeleteConfirmation(true);
    } else if (confirmationType === "block") {
      setShowBlockConfirmation(true);
    }
  };

  const handleCloseConfirmation = () => {
    setShowDeleteConfirmation(false);
    setShowBlockConfirmation(false);
  };

  // blockkk functionality
  const handleBlockConfirmation = (admin) => {
    setAdminToBlock(admin);
    setShowBlockConfirmation(true);
  };

  const handleConfirmBlock = async () => {
    if (adminToBlock) {
      try {
        const newBlockStatus = !adminToBlock.block;

        const response = await axios.put(
          `${Constant.BASE_URL}/admin/updatebyid`,
          { ...adminToBlock, block: newBlockStatus }
        );

        console.log("Response:", response.data);

        if (response.status === 200) {
          setAdmin((prevAdmins) =>
            prevAdmins.map((item) =>
              item._id === adminToBlock._id
                ? { ...item, block: newBlockStatus }
                : item
            )
          );

          const message = newBlockStatus ? "Blocked" : "Unblocked";
          toast.success(`Admin ${message} successfully!`);
        } else {
          toast.error("Failed to update admin status.");
        }

        setShowBlockConfirmation(false);
        setAdminToBlock(null);
      } catch (error) {
        console.error("Error blocking admin:", error);
        toast.error("Failed to update admin status.");
      }
    }
  };

  const handleCloseBlockConfirmation = () => {
    setShowBlockConfirmation(false);
    setAdminToBlock(null);
  };

  // excel shhet download
  const handleExportToExcel = () => {
    if (tableRef.current) {
      const ws = XLSX.utils.table_to_sheet(tableRef.current);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
      XLSX.writeFile(wb, "tablexls.xlsx");
    }
  };
  // paginations
  const handlePageClick = async ({ selected }) => {
    const newPageNumber = selected + 1;
    try {
      const response = await fetch(
        `${Constant.BASE_URL}/admin/get?page=${newPageNumber}`
      );
      const data = await response.json();
      if (data && data.admins) {
        setAdmin(data.admins);
        if (data.success) {
          setTotalCount(data.totalCount);
          setTotalPages(data.totalPages);
          setCurrentPage(newPageNumber);
          setDropdownStates(Array(data.admin.length).fill(false));
        }
      }
      // setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  // get api
  useEffect(() => {
    const fetchUser = async (page) => {
      try {
        const response = await fetch(
          `${Constant.BASE_URL}/admin/get?page=${page}`
        );
        const data = await response.json();
        setAdmin(data);
        if (data && data.admin) {
          setTotalCount(data.totalCount);
          setTotalPages(data.totalPages);
          setCurrentPage(page);
          // Set the initial state for dropdownStates after fetching data
          setDropdownStates(Array(data.admin.length).fill(false));
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUser();
  }, [showAdminForm, editPopup]);

  // Apply filters first, then sorting
  const filteredAdmins = admin
    .filter((a) => (createdByFilter ? a.createdby === createdByFilter : true))
    .filter((a) => {
      if (statusFilter === "blocked") return a.block === true;
      if (statusFilter === "active") return a.block === false;
      return true; // no filter
    });

  // Get sorted and filtered data
  const sortedAndFilteredAdmins = getSortedData(filteredAdmins);

  // unique list of creators
  const uniqueCreators = [...new Set(admin.map((a) => a.createdby))];

  // Get unique createdby values

  // delete api
  const handleOpenDeleteConfirmation = (adminId) => {
    setAdminToDelete(adminId);
    setShowDeleteConfirmation(true);
  };

  const handleDelete = async () => {
    if (adminToDelete) {
      try {
        const response = await axios.delete(
          `${Constant.BASE_URL}/admin/delete/${adminToDelete}`
        );

        if (response.status === 200) {
          setAdmin((prevAdmin) =>
            prevAdmin.filter((admin) => admin._id !== adminToDelete)
          );
          setAdminToDelete(null);
          setShowDeleteConfirmation(false);
          // Success message
          toast.success("Admin deleted successfully");
          setTimeout(() => {
            handleCloseConfirmation();
          }, 3000);
        } else {
          alert("Failed to delete admin");
          toast.error("Failed to delete admin!");
        }
      } catch (error) {
        console.error("Error deleting admin:", error);
        alert("Failed to delete admin");
      }
    }
  };

  return (
    <Sidebar>
      <>
        <ToastContainer position="top-right" autoClose={3000} />
        <div className="p-3 bg-grey-300 lg:p-3 xl:p-3 2xl:p-6">
          <div
            style={{ borderRadius: "0px 0px 11px 11px" }}
            className="bg-white h-[78.55vh]"
          >
            <div className="flex items-center px-4 py-3 bg-white lg:py-2 xl:py-3 2xl:py-3">
              <div className="flex-1">
                <div className="flex justify-between px-10 lg:w-full lg:px-1 ">
                  <div className="flex ">
                    <div className="flex items-center justify-center border border-white rounded-md cursor-pointer ">
                      <div className="text-4lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-bold">
                        <p>Admins : {totalCount}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* third Box */}
              <div className="flex-1 ">
                <div className="flex justify-end">
                  <div className="flex mx-5 border border-white rounded-md ">
                    <img
                      onClick={handleExportToExcel}
                      src={excel}
                      alt="excel"
                      className="w-10  2xl:w-[80px] lg:w-[25px] xl:w-[35px]"
                    />
                  </div>

                  <div
                    style={{
                      background:
                        "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                    }}
                    className="lg:w-fit px-2  2xl:px-3 cursor-pointer  flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px] "
                  >
                    <div
                      onClick={handleCreateAdminClick}
                      className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold"
                    >
                      {" "}
                      <p>Create Admin</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full">
              <div className="tablebodydata overflow-y-auto lg:h-[65vh] xl:h-[64vh] 2xl:h-[67vh] relative ">
                <table
                  ref={tableRef}
                  className="table divide-y divide-gray-200 table-hover table-bordered"
                  id="myTable"
                >
                  <thead className="bg-gray-100">
                    <tr>
                      <th>Action</th>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>
                        <select
                          value={createdByFilter}
                          onChange={(e) => setCreatedByFilter(e.target.value)}
                          className="ml-2 border px-1 py-0.5 rounded text-sm"
                        >
                          <option value="">Created By</option>
                          {uniqueCreators.map((creator, index) => (
                            <option key={index} value={creator}>
                              {creator}
                            </option>
                          ))}
                        </select>
                      </th>
                      <th>                        
                        <select
                          value={statusFilter}
                          onChange={(e) => setStatusFilter(e.target.value)}
                          className="ml-2 border px-1 py-0.5 rounded text-sm"
                        >
                          <option value="">Admin Status</option>
                          <option value="active">Active</option>
                          <option value="blocked">Blocked</option>
                        </select>
                      </th>
                      <th 
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleSort('demoUsers')}
                        className="select-none"
                      >
                        Demo Users
                        {renderSortIcon('demoUsers')}
                      </th>
                      <th 
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleSort('salesUsers')}
                        className="select-none"
                      >
                        Sales Users
                        {renderSortIcon('salesUsers')}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {sortedAndFilteredAdmins &&
                      Array?.isArray(sortedAndFilteredAdmins) &&
                      sortedAndFilteredAdmins?.map((admin, index) => (
                        <tr
                          key={index}
                          className={
                            index % 2 === 0 ? "bg-white" : "bg-gray-100"
                          }
                          style={{
                            background:
                              highlightedId === admin._id ? "yellow" : "none",
                          }}
                        >
                          <td>
                            <div className=" flex justify-center items-center 2xl:text-sm  text-center  border border-white border-opacity-60 bg-white bg-opacity-57 ">
                              <select
                                style={{
                                  boxShadow:
                                    "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                  borderRadius: "5px",
                                }}
                                className=" lg:w-[67px] xl:w-[78px] 2xl:w-[120px] 2xl:text-xl  py-1 text-center  outline-none  border border-white border-opacity-60 bg-white bg-opacity-57 "
                                onChange={(event) =>
                                  handleOptionChange(event, admin)
                                }
                                value={selectedOption}
                              >
                                <option value="">Select</option>
                                <option value="Edit">Edit</option>
                                <option value="Delete">Delete</option>
                                <option value="block">
                                  {admin.block ? "Active" : "Block"}
                                </option>
                              </select>
                            </div>
                          </td>
                          <td>{admin?.name}</td>
                          <td>{admin?.phone}</td>
                          <td>{admin?.createdby}</td>
                          <td className="py-4 px-6 whitespace-nowrap">
                            {admin?.block ? (
                              <span className="text-black">BLOCKED</span>
                            ) : (
                              <span className="text-green-600">Active</span>
                            )}
                          </td>

                          <td>
                            {
                              userRes?.admins?.filter((user) => {
                                console.log("user.createdby:", user?.usertype);
                                console.log(
                                  "admin.createdby:",
                                  admin.createdby
                                );
                                return (
                                  user.createdby === admin.name &&
                                  user.usertype === "Demo"
                                );
                              }).length
                            }
                          </td>
                          <td>
                            {
                              userRes?.admins?.filter((user) => {
                                return (
                                  user?.createdby === admin?.name &&
                                  user?.usertype === "Sales"
                                );
                              }).length
                            }
                          </td>

                          <div className="flex justify-center ">
                            {/* Delete Confirmation Popup */}
                            {showDeleteConfirmation && (
                              <div className="pop-delete">
                                <div className="flex items-center justify-center w-full">
                                  <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md w-fit">
                                    <div className="lg:w-[280px] xl:w-[280px] 2xl:w-[450px] items-center justify-center">
                                      <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl 2xl:py-3">
                                        Do you Want to Delete ?
                                      </div>

                                      <hr className="p-2 mt-1" />
                                      <div className="flex flex-col py-5 justify-center items-center  lg:text-[10px] xl:text-[13px] 2xl:text-[30px] 2xl:py-12">
                                        <button
                                          type="button"
                                          onClick={() =>
                                            setShowDeleteConfirmation(false)
                                          }
                                          className="flex-shrink-0 py-1 bg-white shadow-md text px-7 rounded-sm 2xl:w-32"
                                          style={{
                                            boxShadow:
                                              "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                          }}
                                        >
                                          No
                                        </button>
                                        <button
                                          onClick={() =>
                                            handleDelete(admin._id)
                                          }
                                          className="flex-shrink-0 py-1 mt-5 text-white text px-7 rounded-sm 2xl:w-32"
                                          style={{
                                            background:
                                              "radial-gradient(125% 125% at 85.42% 0%, #FFA6A6 0%, #F00 100%)",
                                          }}
                                        >
                                          Yes
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Block Confirmation Popup */}

                            {showBlockConfirmation && (
                              <div className="pop-delete">
                                <div className="flex items-center justify-center w-full">
                                  <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md w-fit">
                                    <div className="lg:w-[280px] xl:w-[280px] 2xl:w-[450px] items-center justify-center">
                                      <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl 2xl:py-3">
                                        Do you want to{" "}
                                        {adminToBlock?.block
                                          ? "Active"
                                          : "Block"}
                                        ?
                                      </div>
                                      <hr className="p-2 mt-1" />
                                      <div className="flex flex-col py-5 justify-center items-center lg:text-[10px] xl:text-[13px] 2xl:text-[30px] 2xl:py-12">
                                        <button
                                          type="button"
                                          onClick={handleCloseBlockConfirmation}
                                          className="flex-shrink-0 py-1 bg-white shadow-md text px-7 rounded-sm 2xl:w-32"
                                          style={{
                                            boxShadow:
                                              "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                          }}
                                        >
                                          No
                                        </button>
                                        <button
                                          onClick={() => {
                                            handleConfirmBlock(admin);
                                          }}
                                          className="flex-shrink-0 py-1 mt-5 text-white text px-7 rounded-sm 2xl:w-32"
                                          style={{
                                            background:
                                              "radial-gradient(125% 125% at 85.42% 0%, #FFA6A6 0%, #F00 100%)",
                                          }}
                                        >
                                          Yes
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Show  create user form  */}
          {showAdminForm && <CreateAdminsForm onClose={handleClosePopup} />}

          {/* Show  user edit form  */}
          {showEditForm && <EditAdminsForm onClosed={handleCloseEdit} />}
        </div>
      </>
      {/* Pagination code*/}
      <div className="flex lg:px-4">
        <div className="w-full  flex  bg-white  bg-white shadow-md backdrop-blur-[5.7px]">
          <div className="w-full  flex  items-center fixed lg:bottom-5 xl:bottom-6 2xl:bottom-6 border-t lg:text-[10px] xl:text-[14px] 2xl:text-3xl lg:pt-1 xl:pt-1 2xl:pt-0">
            <div className="flex justify-start w-full xl:px-5 2xl:p-5">
              <p>
                Showing{" "}
                <span className="text-blue-500">
                  {(currentPage - 1) * 15 + 1}{" "}
                </span>
                to{" "}
                <span className="text-blue-500">
                  {Math.min(currentPage * 15, totalCount)}{" "}
                </span>
                of <span className="text-yellow-500">{totalCount}</span> entries
              </p>
            </div>
            {/* pagination code */}
            <div className="flex justify-start pr-2 text-blue-500 pagination xl:pr-5">
              <ReactPaginate
                previousLabel={""}
                nextLabel={""}
                breakLabel={"...."}
                pageCount={totalPages}
                marginPagesDisplayed={1}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
                className="flex justify-start"
              />
            </div>
          </div>
        </div>
      </div>
      {editPopup && (
        <EditAdminForm editPopup={editPopup} setEditPopup={setEditPopup} />
      )}
    </Sidebar>
  );
}